// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__F_Z73","options":"AnswerScale_options__mTD2G","selected":"AnswerScale_selected__v5QFJ"};